<template>
  <Modal :show="true" @close="$emit('close')" clickaway class="residential-template-sync">
    <Card tag="form" class="residential-template-sync__card" theme="flat" @submit.prevent="submit">
      <template #default>
        <div class="residential-template-sync__inputs">
          <InputComponent :label="$t('fieldsToSync')">
            <template #default>
              <div class="residential-template-sync__scroller">
                <ChecklistComponent v-model="data.fields" :items="fields" class="elder-input__element" />
              </div>
            </template>
            <template #below>
              <Alert theme="warning" class="mt-2">{{ $t('syncReferencesWarning') }}</Alert>
            </template>
          </InputComponent>
          <InputComponent :label="$tc('unit', 2)" data-field="references">
            <template #default>
              <div class="residential-template-sync__scroller">
                <ChecklistComponent
                  v-model="data.ids"
                  select-all
                  :group-by="{ path: 'data.project.id', label: 'data.project.name' }"
                  :items="fetchResidentials"
                  class="elder-input__element"
                />
              </div>
            </template>
          </InputComponent>
        </div>
      </template>
      <template #footer>
        <ButtonComponent :label="$t('cancel')" :icon="['fal', 'times']" @click="$emit('close')" />
        <ButtonComponent
          :label="$t('update')"
          :icon="['fal', 'arrow-to-right']"
          theme="primary"
          type="submit"
          confirm
          :disabled="!data.fields.length || !data.ids.length"
          :promise="promise"
          @onSuccess="$emit('close')"
        />
      </template>
    </Card>
  </Modal>
</template>

<script>
import { Clone } from '@/utils'
import API from '@/api/ResidentialTemplate'
import ResidentialApi from '@/api/Residential'

import { ModalComponent as Modal } from 'vue-elder-modal'
import { AlertComponent as Alert } from 'vue-elder-alert'
import Card from '@/components/Card'
import { InputComponent } from 'vue-elder-input'
import { CheckboxComponent } from 'vue-elder-checkbox'
import ChecklistComponent from '@/components/Select/Checklist'

const Model = {
  fields: [],
  ids: [],
}

export default {
  props: {
    id: String,
  },
  data() {
    return {
      data: null,
      promise: null,
    }
  },
  computed: {
    fields() {
      return [
        { value: 'sale.value', label: this.$t('price') },
        { value: 'properties', label: `${this.$t('residentialProperties')} / ${this.$tc('facility', 2)}` },
        { value: 'description', label: this.$t('description') },
        { value: 'media.cover', label: this.$t('cover') },
        { value: 'media.gallery', label: this.$t('gallery') },
        { value: 'media.floorplan', label: this.$tc('floorplan', 2) },
        { value: 'media.attachments', label: this.$tc('attachment', 2) },
      ]
    },
  },
  methods: {
    submit() {
      this.promise = API.mutate(
        {
          id: this.id,
          data: this.data,
        },
        {
          transformPayload: false,
          mutation: 'ResidentialTemplateSync',
        },
      )
    },
    fetchResidentials() {
      return ResidentialApi.get(
        { filter: { template: this.id }, sort: { key: 'number', value: 1 } },
        { query: 'ResidentialSearch' },
      ).then(data =>
        data
          .sort((a, b) => {
            if (a.project.name < b.project.name) return -1
            if (a.project.name > b.project.name) return 1
            return 0
          })
          .map(e => ({
            value: e.id,
            label: `${this.$tc('residential')} ${e.number}`,
            data: e,
          })),
      )
    },
  },
  created() {
    this.data = Clone(Model)
  },
  components: {
    Card,
    Modal,
    InputComponent,
    CheckboxComponent,
    ChecklistComponent,
    Alert,
  },
}
</script>

<style lang="scss">
.residential-template-sync {
  &__card {
    width: 100%;
    max-width: 1000px;
  }

  &__scroller {
    max-height: 350px;
    overflow-y: scroll;

    @include scrollShadow();
  }

  &__inputs {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: 2rem;
  }
}
</style>
